const viewportHorizontalMarginPx = 32;
const viewportFallbackWidthPx = 672;
const viewportMaxWidthPx = 560;
const viewportMinWidthPx = 240;
const countedDropdownMinWidthPx = 300;
const tagChipDropdownWidthPx = 192;

export const tagsFilterDropdownViewportMaxWidth = 'min(560px, calc(100vw - 32px))';

type ResolveTagsFilterDropdownWidthInput = {
  controlWidthPx: number;
  hasCountColumn: boolean;
  hasCountIconColumn: boolean;
  showOptionChips: boolean;
  viewportWidthPx?: number;
};

const resolveViewportMaxWidth = (viewportWidthPx: number): number =>
  Math.max(
    viewportMinWidthPx,
    Math.min(viewportMaxWidthPx, viewportWidthPx - viewportHorizontalMarginPx),
  );

export const resolveTagsFilterDropdownWidthPx = ({
  controlWidthPx,
  hasCountColumn,
  hasCountIconColumn,
  showOptionChips,
  viewportWidthPx = viewportFallbackWidthPx,
}: ResolveTagsFilterDropdownWidthInput): number => {
  if (!hasCountColumn) {
    return controlWidthPx;
  }

  const resolvedViewportMaxWidth = resolveViewportMaxWidth(viewportWidthPx);
  if (showOptionChips) {
    return Math.min(tagChipDropdownWidthPx, resolvedViewportMaxWidth);
  }

  if (hasCountIconColumn) {
    return Math.min(controlWidthPx, resolvedViewportMaxWidth);
  }

  return Math.min(Math.max(controlWidthPx, countedDropdownMinWidthPx), resolvedViewportMaxWidth);
};
